export function getStoryBibleSelection(): string {
  const activeEl = document.activeElement;
  const container = document.querySelector("[data-story-bible-content]");
  if (!container) return "";

  if (
    activeEl instanceof HTMLTextAreaElement &&
    container.contains(activeEl) &&
    activeEl.selectionStart !== activeEl.selectionEnd
  ) {
    return activeEl.value.substring(activeEl.selectionStart, activeEl.selectionEnd);
  }

  const sel = window.getSelection();
  if (!sel || sel.isCollapsed || !sel.rangeCount) return "";

  const range = sel.getRangeAt(0);
  if (container.contains(range.commonAncestorContainer)) {
    return sel.toString().trim();
  }

  return "";
}

export function isFocusInsideAgenticComposer(): boolean {
  if (typeof document === "undefined") return false;
  const activeElement = document.activeElement;
  if (!(activeElement instanceof Element)) return false;
  return !!activeElement.closest("[data-agentic-chat-composer='true']");
}

export function handleStoryBibleSelectionChange(
  setActiveHighlight: (text: string, highlightHtml?: string, selectionHint?: null) => void,
  clearDismissedHighlight: () => void,
  /** When provided, avoids clearing passage context if the manuscript still has a range. */
  getManuscriptSelection?: () => string,
): void {
  const activeEl = document.activeElement;
  const container = document.querySelector("[data-story-bible-content]");
  if (!container) return;

  const isActiveInStoryBible = activeEl && container.contains(activeEl);
  const selectedText = getStoryBibleSelection();

  if (selectedText) {
    // Story Bible highlights are not manuscript-scoped; clear any persisted editor hint.
    setActiveHighlight(selectedText, undefined, null);
  } else if (isActiveInStoryBible) {
    setActiveHighlight("", undefined, null);
  } else {
    clearDismissedHighlight();
    const manuscript = getManuscriptSelection?.() ?? "";
    if (!manuscript.trim()) {
      // Window selection often collapses when focus moves into chat before this handler runs,
      // but we keep SB / passage context for the next message (matches manuscript UX).
      if (isFocusInsideAgenticComposer()) return;
      setActiveHighlight("");
    }
  }
}
